<template>
    <chart type="line" :data="chartData" />
</template>

<script>
import chart from '@/components/ui/chart/chart.vue'
import { moneyFormat } from '@/helpers.ts'

export default {
    components: { chart },
    props: {
        years: Array,
        stat: Object
    },
    computed: {
        amountList() { 
            return this.$props.years.map(y => parseFloat(this.$props.stat[y].opened.sum_total + this.$props.stat[y].closed.sum_total).toFixed(2)) },
        chartData() {
            return {
                labels: this.$props.years || [],
                datasets: [{
                    label: "Общая сумма, руб",
                    fill: false,
                    backgroundColor: "#e74c3c",
                    borderColor: "#e74c3c",
                    pointBorderColor: "#e74c3c",
                    pointBackgroundColor: "#fff",
                    borderWidth: 1,
                    data: this.amountList || [],
                }]
            }
        }
    },
    mounted(){
        $('#tiles').trigger('resize')
    }
}
</script>

<style lang="sass" scoped>

</style>